var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldFilterSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.87 3.05C18.92 2.36 17.68 2 16.19 2H7.81c-.2 0-.4.01-.59.03C3.94 2.24 2 4.37 2 7.81v8.38c0 1.49.36 2.73 1.05 3.68.29.42.66.79 1.08 1.08.82.6 1.86.95 3.09 1.03.19.01.39.02.59.02h8.38c3.64 0 5.81-2.17 5.81-5.81V7.81c0-1.49-.36-2.73-1.05-3.68-.29-.42-.66-.79-1.08-1.08zm-11.9 7.12c-.26-.26-.47-.73-.47-1.05v-1.2c0-.63.47-1.1 1.05-1.1h2.14c.41 0 .66.45.44.8L9.28 10.6c-.18.29-.59.33-.82.08l-.49-.51zm8.01.05-2.25 1.99c-.31.26-.52.78-.52 1.2v2.25c0 .31-.21.73-.47.89l-.74.47c-.68.42-1.62-.05-1.62-.89v-2.77c0-.37-.21-.84-.42-1.1L9.72 12a.542.542 0 0 1-.07-.64l2.68-4.3c.1-.15.26-.25.44-.25h2.68c.58 0 1.05.47 1.05 1.05v1.16c0 .42-.26.94-.52 1.2z",
    fill: "{props.color}",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldFilterSquare);
export default __webpack_public_path__ + "static/media/vuesax-bold-filter-square.76eb5500d75c082c218e1be4f684c0ce.svg";
export { ForwardRef as ReactComponent };